import React from "react";
import { View, Text } from "@react-pdf/renderer";
import { StrikeZonePDF } from "../StrikeZonePDF";
import { reportStyles } from "./styles";
import { toTitleCase, formatPitchType } from "./utils";

export const StrikeZoneGrid = ({
  pitchData,
  compact = false,
  containerWidth = "32%",
  showAll = true,
}) => {
  const gridStyle = compact
    ? reportStyles.strikeZoneGridCompact
    : reportStyles.strikeZoneGrid;
  const containerStyle =
    containerWidth === "30%"
      ? reportStyles.strikeZoneContainerSmall
      : reportStyles.strikeZoneContainer;

  const items = showAll
    ? Object.entries(pitchData)
    : Object.entries(pitchData).filter(([_, data]) => !data.isAll);

  return (
    <View style={gridStyle}>
      {items.map(([type, data]) => (
        <View key={type} style={containerStyle}>
          <Text style={reportStyles.strikeZoneTitle}>
            {formatPitchType(type) || toTitleCase(type)}
          </Text>
          <StrikeZonePDF
            pitches={data.pitches || data}
            width={150}
            height={150}
          />
        </View>
      ))}
    </View>
  );
};
